/* Soraya – Adjustable Warming Mat landing page */
(function () {
  function initSection(root) {
    if (!root || root.dataset.swReady === 'true') return;
    root.dataset.swReady = 'true';

    /* ---- gallery ---- */
    var slides = root.querySelectorAll('.sw-gallery__slide');
    var thumbs = root.querySelectorAll('.sw-gallery__thumb');
    var index = 0;

    function show(i) {
      if (!slides.length) return;
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      index = i;
      for (var s = 0; s < slides.length; s++) {
        slides[s].classList.toggle('is-active', s === index);
      }
      for (var t = 0; t < thumbs.length; t++) {
        thumbs[t].classList.toggle('is-active', t === index);
      }
    }

    for (var t = 0; t < thumbs.length; t++) {
      (function (i) {
        thumbs[i].addEventListener('click', function () { show(i); });
      })(t);
    }

    var prev = root.querySelector('.sw-gallery__arrow--prev');
    var next = root.querySelector('.sw-gallery__arrow--next');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });

    /* ---- option buttons ---- */
    function wireGroup(selector) {
      var buttons = root.querySelectorAll(selector);
      for (var b = 0; b < buttons.length; b++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            for (var k = 0; k < buttons.length; k++) {
              buttons[k].classList.remove('is-active');
            }
            btn.classList.add('is-active');
          });
        })(buttons[b]);
      }
    }
    wireGroup('.sw-swatch');
    wireGroup('.sw-size');

    /* ---- autoplay videos only while visible ---- */
    var videos = root.querySelectorAll('video');
    if (videos.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            var playing = v.play();
            if (playing && typeof playing.catch === 'function') playing.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.35 });
      for (var v = 0; v < videos.length; v++) io.observe(videos[v]);
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('.sw');
    for (var i = 0; i < roots.length; i++) initSection(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initSection(e.target.querySelector('.sw'));
  });
})();
